export default class TeamGriffinAdmin {

    static init(){
        if($('.admin-page.team-griffin').length > 0){
            window.TeamGriffinAdmin = new this();
        }
    }
    constructor(){
        this.ui = {
            roster: {
                template: $('#roster_template'),
                buttonAdd: $('#add_roster_button'),
                field: $('#roster_name'),
            },
        };

        this.ui.roster.buttonAdd.click(()=>this.addRoster());
    }
    addRoster(){
        let rosterName = this.ui.roster.field.val();
        if(!rosterName) {
            this.ui.roster.field.focus();
            return;
        }
        this.ui.roster.field.val('');

        let roster = this.ui.roster.template.clone();
        roster.data('playerNumber', 0);
        roster.removeAttr('id');
        roster.find('h2').html('Team Griffin '+rosterName+' Roster');
        roster.find('.add_player_button').click(()=>this.addPlayer(roster, rosterName));
        roster.find('.remove_roster').click(()=>roster.remove());
        roster.insertBefore(this.ui.roster.template);
        this.addPlayer(roster, rosterName);
        roster.removeAttr('hidden');

    }
    addPlayer(roster, rosterName){
        let playerTemplate = roster.find('.player.template');
        let player = playerTemplate.clone();

        let playerNumber = roster.data('playerNumber');
        roster.data('playerNumber', playerNumber+1+Math.random());
        player.find('.jersey_number.template').attr('name', 'rosters['+rosterName+']['+playerNumber+'][jersey_number]');
        player.find('.name.template').attr('name', 'rosters['+rosterName+']['+playerNumber+'][name]');
        player.find('.position.template').attr('name', 'rosters['+rosterName+']['+playerNumber+'][position]');
        player.find('.school_city.template').attr('name', 'rosters['+rosterName+']['+playerNumber+'][school_city]');
        player.find('.class.template').attr('name', 'rosters['+rosterName+']['+playerNumber+'][class]');

        player.removeClass('template');
        player.find('.remove_player').click(()=>player.remove());
        player.insertBefore(playerTemplate);
        player.removeAttr('hidden');
        player.find('.jersey_number').focus();
    }
}


// WEBPACK FOOTER //
// ./public/js/TeamGriffinAdmin.js